import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearCredentials } from '../../store/authSlice';
import styles from './Main.module.css';

const Main = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromAuth = location.state?.fromAuth === true;
  const dispatch = useDispatch();
  const username = useSelector((state) => state.auth.username);

  const playGame = () => navigate('/startgame');
  const seeAccount = () => navigate('/accounthome');
  const seeLeaderboard = () => navigate('/leaderboard');

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    dispatch(clearCredentials());
    navigate('/');
  };

  return (
    <div className={`${styles.container} ${fromAuth ? styles.entranceFade : ''}`}>
      <button className={styles.logoutBtn} onClick={handleLogout}>Logout</button>
      <p className={styles.welcome}>Welcome back {username}!</p>
      <h1 className={styles.title}>Paddr Tracker</h1>
      <div className={styles.table}>
        <div className={styles.centerLine} />
        <div className={styles.centerCircle} />
        <div className={styles.centerDot} />
        <div className={styles.goalBoxLeft} />
        <div className={styles.goalBoxRight} />

        <button className={`${styles.cupItem} ${styles.cupLeft}`} onClick={playGame}>
          <div className={styles.cupWrapper}>
            <div className={styles.cup} />
            <div className={styles.ball} />
          </div>
          <span className={styles.cupLabel}>Play Game</span>
        </button>

        <button className={`${styles.cupItem} ${styles.cupCenter}`} onClick={seeLeaderboard}>
          <div className={styles.cupWrapper}>
            <div className={styles.cup} />
            <div className={styles.ball} />
          </div>
          <span className={styles.cupLabel}>Leaderboard</span>
        </button>

        <button className={`${styles.cupItem} ${styles.cupRight}`} onClick={seeAccount}>
          <div className={styles.cupWrapper}>
            <div className={styles.cup} />
            <div className={styles.ball} />
          </div>
          <span className={styles.cupLabel}>Manage Account</span>
        </button>
      </div>
    </div>
  );
};

export default Main;
